<ng-container *ngIf="asset != null">
  <div
    *ngIf="asset.GroupName && asset.GroupID"
    class="prop breadcrumb-link"
    (click)="
      navigateTo({
        PanelName: 'group',
        Params: { Name: asset.GroupName, ID: asset.GroupID }
      })
    "
  >
    <b>{{ "COLUMNS.GROUP" | translate }}:</b> {{ asset.GroupName }}
  </div>

  <div class="prop" *ngIf="asset.DepartmentName && asset.DepartmentID">
    <b>{{ "COLUMNS.DEPARTMENT" | translate }}:</b> {{ asset.DepartmentName }}
  </div>

  <div class="prop" *ngIf="asset.BedStatus">
    {{ "COLUMNS.BED_STATUS" | translate }}: {{ asset.BedStatus }}
  </div>

  <div class="prop" *ngIf="asset.Email">
    {{ "COLUMNS.EMAIL_ADDRESS" | translate }}: {{ asset.Email }}
  </div>

  <div
    *ngFor="let device of asset.AssociatedDevices"
    class="prop breadcrumb-link"
    (click)="
      navigateTo({
        PanelName: 'device',
        Params: {
          Name: device.UniqueId,
          ID: device.Id
        }
      })
    "
  >
    <b>{{ "COLUMNS.PAIRED_DEVICE" | translate }}:</b> {{ device.Name }}
  </div>
  <div class="prop" *ngIf="asset.AssociatedDevices.length == 0">
    {{ "COLUMNS.NO_PAIRED_DEVICE" | translate }}
  </div>

  <div
    *ngIf="asset.AssocItemID && asset.AssocItemName"
    class="prop breadcrumb-link"
    (click)="
      navigateTo({
        PanelName: 'asset',
        Params: { Name: asset.AssocItemName, ID: asset.AssocItemID }
      })
    "
  >
    {{ "COLUMNS.ASSOC_ASSET" | translate }}: {{ asset.AssocItemName }}
  </div>

  <!-- MKL new props to show 8-10-2023 -->
  <div class="prop" *ngIf="asset.BuildingName && asset.FloorName">
    {{ "COLUMNS.LOCATION" | translate }}: {{ asset.BuildingName }} -
    {{ asset.FloorName }}
  </div>
  <div class="prop" *ngIf="asset.LocationUpdated">
    {{ "COLUMNS.LOCATION_UPDATED" | translate }}: {{ asset.LocationUpdated }}
  </div>

  <!-- STATUSES -->
  <div
    class="list"
    *ngIf="asset.UserDefinedStatuses && asset.UserDefinedStatuses.length > 0"
  >
    <b>{{ "COLUMNS.STATUSES" | translate }}</b>
    <hr />
    <p *ngFor="let status of asset.UserDefinedStatuses">
      <img
        style="display: inline"
        class="icon"
        [matTooltip]="status.Name"
        [src]="status.Icon"
      />
      {{ status.Name + " - " }}
      {{ status.Description }}
    </p>
  </div>

  <!-- TELEMETRY STATUSES -->
  <div
    class="list"
    *ngIf="asset.TelemetryDatas && asset.TelemetryDatas.length > 0"
  >
    <b>{{ "COLUMNS.TELEMETRY_DATA" | translate }}</b>
    <hr />
    <p *ngFor="let data of asset.TelemetryDatas">
      {{ data.TopicName + " - " }}
      {{ data.Value }}
    </p>
  </div>

  <!-- UDA -->
  <div
    class="list"
    *ngIf="
      asset.UserDefinedAttributes && asset.UserDefinedAttributes.length > 0
    "
  >
    <b>{{ "COLUMNS.UDA_DESCRIPTION" | translate }}:</b>
    <hr />
    <p *ngFor="let uda of asset.UserDefinedAttributes" class="key-value">
      <ng-container *ngIf="uda.AttributeType == 'String'">
        <span>{{ uda.AttributeName }}</span>
        <span *ngIf="uda.AttrString">{{ uda.AttrString }}</span>
        <span *ngIf="!uda.AttrString">N/A</span>
      </ng-container>
      <ng-container *ngIf="uda.AttributeType == 'DateTime'">
        <span>{{ uda.AttributeName }}</span>
        <span *ngIf="uda.AttrString">{{ uda.AttrString }}</span>
        <span *ngIf="!uda.AttrString">N/A</span>
      </ng-container>
      <ng-container *ngIf="uda.AttributeType == 'Int'">
        <span>{{ uda.AttributeName }}</span>
        <span *ngIf="uda.AttrInt">{{ uda.AttrInt }}</span>
        <span *ngIf="!uda.AttrInt">N/A</span>
      </ng-container>
      <ng-container *ngIf="uda.AttributeType == 'Decimal'">
        <span>{{ uda.AttributeName }}</span>
        <span *ngIf="uda.AttrInt">{{ uda.AttrDouble }}</span>
        <span *ngIf="!uda.AttrInt">N/A</span>
      </ng-container>
      <ng-container *ngIf="uda.AttributeType == 'YesNo'">
        <span>{{ uda.AttributeName }}</span>
        <span>{{ uda.AttrBool?.toString() }}</span>
      </ng-container>
    </p>
  </div>

  <app-shared-map
    *ngIf="asset != null"
    [data]="asset"
    [inputType]="'asset'"
    style="width: 98%"
  ></app-shared-map>
</ng-container>
